import { useCallback, useState } from 'react';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { ThumbsUpIcon } from 'foundations-assets';
import * as http from 'reporting-data/request/http';
import { USER_FEEDBACK_URL } from '../../singleReportViewer/fullPage/report-ai-assistant-insights/utils';
import FeedbackPopoverContainer from './FeedbackPopoverContainer';
import { sendReportingInsightsUserFeedbackForReportingBackend } from './api';
import { REPORTING_AI_ASSISTANT_FEEDBACK_TYPE } from './feedbackConstants';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const PositiveFeedbackButton = ({
  insight,
  correlationId,
  disableFeedback,
  setDisableFeedback,
  report,
  dataset
}) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const onHelpfulClick = useCallback(() => {
    setPopoverOpen(true);
    const verificationResult = insight.verificationResult;
    const insightCorrelationId = insight.correlationId;
    if (verificationResult) {
      http.post(USER_FEEDBACK_URL, {
        data: [{
          correlationId,
          acceptedValues: [insight.value],
          rejectedValues: []
        }, {
          correlationId: insightCorrelationId,
          acceptedValues: [verificationResult.toString()],
          rejectedValues: []
        }]
      });
    } else {
      http.post(USER_FEEDBACK_URL, {
        data: [{
          correlationId,
          acceptedValues: [insight.value],
          rejectedValues: []
        }, {
          correlationId: insightCorrelationId,
          acceptedValues: [],
          rejectedValues: [verificationResult.toString()]
        }]
      });
    }
    sendReportingInsightsUserFeedbackForReportingBackend({
      report,
      insight,
      dataset,
      correlationId,
      feedbackValue: true
    });
  }, [insight, report, dataset, correlationId]);
  return /*#__PURE__*/_jsx(FeedbackPopoverContainer, {
    correlationId: correlationId,
    feedbackType: REPORTING_AI_ASSISTANT_FEEDBACK_TYPE.POSITIVE,
    popoverOpen: popoverOpen,
    setPopoverOpen: setPopoverOpen,
    insight: insight,
    setDisableFeedback: setDisableFeedback,
    report: report,
    dataset: dataset,
    children: /*#__PURE__*/_jsx(IconButton, {
      disabled: disableFeedback,
      "data-test-id": "reporting-ai-assistant-positive-feedback",
      use: "link",
      onClick: onHelpfulClick,
      tooltip: I18n.text('reporting-enablement.feedbackButtons.likeResponse'),
      "aria-label": I18n.text('reporting-enablement.feedbackButtons.likeResponse'),
      children: /*#__PURE__*/_jsx(ThumbsUpIcon, {})
    })
  });
};
export default PositiveFeedbackButton;